import { render, staticRenderFns } from "./SuccessLead.vue?vue&type=template&id=05b66943"
import script from "./SuccessLead.vue?vue&type=script&lang=js"
export * from "./SuccessLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports